import { useEffect, useState } from "react";
import {
  Button,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Loading,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "../../../../components";
import { ExportacaoBalancaService } from "../../../../services";
import { responseErros } from "../../../../utils";
import { format } from "date-fns";

export default function ExportacaoBalancaDialog({ open, setOpen, loading, setLoading }) {
  const [modeloBalanca, setModeloBalanca] = useState("filizola");
  const [configEtiqueta, setConfigEtiqueta] = useState(null);
  const [mensagemLog, setMensagemLog] = useState("");

  const exportacaoBalancaService = new ExportacaoBalancaService();

  async function buscarUltimoLog() {
    const result = await exportacaoBalancaService.getUltimoLog();
    if (!result.isAxiosError) {
      let mensagem = "Não há registros de exportação anterior";
      if (result.data) {
        const dataUltimaExportacao =
          result.data.updatedAt ?? result.data.createdAt;
        const dataFormatada = format(new Date(dataUltimaExportacao), "dd/MM/yyyy HH:mm");
        mensagem = `Última exportação realizada em ${dataFormatada}`;
      }
      setMensagemLog(mensagem);
    } else {
      responseErros(result);
    }
  }

  useEffect(() => {
    if (open) {
      buscarUltimoLog();
    }
  }, [open]);

  const handleChangeConfigEtiqueta = (event) => {
    const value = event.target.value.replace(/[^0-9]/g, "").slice(0, 2);
    setConfigEtiqueta(value);
  };

  async function handleExportarCarga() {
    setLoading(true);
    const body = {
      modeloBalanca,
      configEtiqueta,
    };
    const result = await exportacaoBalancaService.getCargaBalanca(body);
    if (!result.isAxiosError) {
      const fileName = modeloBalanca === 'filizola' ? "CADTXT.TXT" : "TXTITENS.TXT";
      const buffer = new Uint8Array(result.data.data);
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } else {
      responseErros(result);
    }

    setLoading(false);
  }

  return (
    <>
      <Dialog
        maxWidth="sm"
        fullWidth
        open={open}
        onClose={() => setOpen(false)}
      >
        <DialogContent sx={{ paddingBottom: "0px !important" }}>
          <CardHeader title="Exportação de Produtos para Balança" />
          <CardContent className="mt-2">
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Select
                  id="modeloBalanca"
                  name="modeloBalanca"
                  value={modeloBalanca}
                  label="Modelo de Balança"
                  disableClearable
                  onChange={(e) => {
                    const modelo = e.target.value;
                    const config = modelo === "toledo" ? "03" : null;
                    setConfigEtiqueta(config);
                    setModeloBalanca(e.target.value);
                  }}
                  fullWidth
                >
                  <MenuItem value={"filizola"}>Filizola Platina</MenuItem>
                  <MenuItem value={"toledo"}>Toledo Prix 4</MenuItem>
                </Select>
              </Grid>
              {modeloBalanca === "toledo" && (
                <Grid item xs={2}>
                  <TextField
                    id="configEtiqueta"
                    label={"Nº Config. Etiqueta"}
                    fullWidth
                    value={configEtiqueta}
                    margin="none"
                    onChange={handleChangeConfigEtiqueta}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <Typography variant="caption">{mensagemLog}</Typography>
              </Grid>
            </Grid>
          </CardContent>
        </DialogContent>
        <DialogActions
          sx={{
            overflow: "auto",
            position: "sticky",
            bottom: 0,
            margin: 1,
            backgroundColor: "white",
            justifyContent: "flex-end",
            marginLeft: 4,
            paddingTop: "0 !important",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleExportarCarga}
          >
            <i
              className="ph-fill ph-check-circle"
              style={{ color: "#fff", fontSize: 22, marginRight: 10 }}
            ></i>
            Exportar
          </Button>
          <Button
            variant="contained"
            color="padrao"
            onClick={() => setOpen(false)}
          >
            <i
              className={`ph-fill ph-x-circle`}
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
      <Loading loading={loading} />
    </>
  );
}
